import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { __decorate } from "tslib";
import { endProductList, endProductDetail } from '@/services/http';
import { Component, Vue } from 'vue-property-decorator';
// import { State, Action } from 'vuex-class';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import BackTop from '@/common/backtop.vue';
// import { readCookie, dateFormatter } from '@/tools/tools';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.isVisible = false;
    _this.endProductType = 0;
    // 所选耗材图片
    _this.selectImg = '';
    _this.selectDetailsImg = [];
    _this.dialogVisible = false;
    // 标签宽度
    _this.width = '';
    // 标签高度
    _this.height = '';
    _this.orderNum = '';
    // 包装类型名称
    _this.packageTypeName = '';
    // 排数类型名称
    _this.rowTypeName = '';
    // 方向类型名称
    _this.directionTypeName = '';
    // 边角类型名称
    _this.cornerTypeName = '';
    // 尺寸列表
    _this.sizeList = [];
    _this.listData = [{
      label: 1,
      value: '13mm（小卷芯，建议便携标签机使用）'
    }, {
      label: 2,
      value: '25mm（小卷芯，建议便携标签机使用）'
    }, {
      label: 3,
      value: '40mm（中卷芯，建议桌面标签机使用）'
    }, {
      label: 4,
      value: '76mm（大卷芯，建议工业标签机使用)'
    }];
    // 笔芯直径
    _this.option = '13mm（小卷芯，建议便携标签机使用）';
    _this.addIndex = 0;
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.getEndProductList();
    }
  }, {
    key: "beforeRouteLeave",
    value: function beforeRouteLeave(to, from, next) {
      if (to.name === 'material') {
        this.$vnode.parent.componentInstance.cache = {};
        this.$vnode.parent.componentInstance.keys = [];
      }
      next(true);
    }
    // 获取设置列表
  }, {
    key: "getEndProductList",
    value: function () {
      var _getEndProductList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2 = this;
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return endProductList({
                companyId: 1
              });
            case 2:
              res = _context.sent;
              this.sizeList = res.data.data;
              this.sizeList.forEach(function (value) {
                value.fileList.forEach(function (element, index, arr) {
                  _this2.$set(element, 'selected', false);
                  _this2.$set(arr[0], 'selected', true);
                });
              });
              this.endProductType = this.sizeList[0].fileList[0].endProductType;
              this.packageTypeName = this.sizeList[0].fileList.filter(function (value) {
                return value.selected;
              })[0].endProductTypeName;
              this.rowTypeName = this.sizeList[1].fileList.filter(function (value) {
                return value.selected;
              })[0].endProductTypeName;
              this.directionTypeName = this.sizeList[2].fileList.filter(function (value) {
                return value.selected;
              })[0].endProductTypeName;
              this.cornerTypeName = this.sizeList[3].fileList.filter(function (value) {
                return value.selected;
              })[0].endProductTypeName;
              this.getEndProductDetail();
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getEndProductList() {
        return _getEndProductList.apply(this, arguments);
      }
      return getEndProductList;
    }()
  }, {
    key: "showViewer",
    value: function showViewer() {
      var viewer = this.$refs.images.$viewer;
      viewer.show();
    }
    // 选择设置展示介绍图片
  }, {
    key: "showProductImg",
    value: function () {
      var _showProductImg = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(id, typeid, index, key) {
        var _this3 = this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.endProductType = typeid;
              this.sizeList[index].fileList.forEach(function (element, indexval, arr) {
                _this3.$set(element, 'selected', false);
                _this3.$set(arr[key], 'selected', true);
              });
              this.packageTypeName = this.sizeList[0].fileList.filter(function (value) {
                return value.selected;
              })[0].endProductTypeName;
              this.rowTypeName = this.sizeList[1].fileList.filter(function (value) {
                return value.selected;
              })[0].endProductTypeName;
              this.directionTypeName = this.sizeList[2].fileList.filter(function (value) {
                return value.selected;
              })[0].endProductTypeName;
              this.cornerTypeName = this.sizeList[3].fileList.filter(function (value) {
                return value.selected;
              })[0].endProductTypeName;
              this.getEndProductDetail();
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function showProductImg(_x, _x2, _x3, _x4) {
        return _showProductImg.apply(this, arguments);
      }
      return showProductImg;
    }()
  }, {
    key: "getEndProductDetail",
    value: function () {
      var _getEndProductDetail = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return endProductDetail({
                endProductType: this.endProductType,
                companyId: 1
              });
            case 2:
              res = _context3.sent;
              this.selectImg = res.data.data.mallImage.sourceUrl;
              this.selectDetailsImg = res.data.data.detail;
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getEndProductDetail() {
        return _getEndProductDetail.apply(this, arguments);
      }
      return getEndProductDetail;
    }()
  }, {
    key: "selectDiameter",
    value: function selectDiameter(value, index) {
      this.option = value;
      this.addIndex = index;
      this.isVisible = false;
    }
    // 下一步
  }, {
    key: "next",
    value: function next() {
      if (this.width === '') {
        this.$message.error('请输入标签宽度！');
      } else if (this.height === '') {
        this.$message.error('请输入标签高度！');
      } else if (this.orderNum === '') {
        this.$message.error('请输入定制张数！');
      } else {
        var size = "".concat(this.width, "*").concat(this.height);
        var _this$$route$query = this.$route.query,
          materialName = _this$$route$query.materialName,
          materialId = _this$$route$query.materialId;
        this.$router.push("/erial-selecttag?diameter=".concat(this.packageTypeName === '卷筒装' ? this.option : '', "&size=").concat(size, "&orderNum=").concat(this.orderNum, "&packageTypeName=").concat(this.packageTypeName, "\n        &rowTypeName=").concat(this.rowTypeName, "&directionTypeName=").concat(this.directionTypeName, "\n        &cornerTypeName=").concat(this.cornerTypeName, "&materialName=").concat(materialName, "&materialId=").concat(materialId));
      }
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    NavMenu: NavMenu,
    BackTop: BackTop
  }
})], default_1);
export default default_1;